export default __webpack_public_path__ + "static/media/redCloseIcon.5695af80.jpeg";